import React, { useState } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
type Errors = {
  name?: string;
  email?: string;
  message?: string;
};
const fieldClass = 'mt-1.5 w-full rounded-lg border border-hairline bg-white px-3.5 py-2.5 text-[15px] text-ink placeholder:text-ink-light focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent';
export function ContactForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState<Errors>({});
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const next: Errors = {};
    if (!name.trim()) next.name = 'Please enter your name.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) next.email = 'Please enter a valid email address.';
    if (!message.trim()) next.message = 'Please enter a message.';
    setErrors(next);
    if (Object.keys(next).length > 0) return;
    setSubmitted(true);
  };
  if (submitted) {
    return <div role="status" className="flex h-full flex-col items-start justify-center rounded-2xl border border-hairline bg-white p-8 shadow-card" data-id="element-46" data-mp="3ujhue30xvrin">
        <CheckCircle2Icon className="h-7 w-7 text-accent" aria-hidden="true" data-id="element-47" data-mp="84p05bkmvlk7" />
        <h3 className="mt-4 text-lg font-semibold text-ink" data-id="element-48" data-mp="86rntoybd2lr">
          Thank you for reaching out
        </h3>
        <p className="mt-2 text-[15px] leading-relaxed text-ink-muted" data-id="element-49" data-mp="36onjzrdwp1fh">
          We have received your message and a member of our team will reply by
          email within two business days.
        </p>
      </div>;
  }
  return <form onSubmit={handleSubmit} noValidate className="rounded-2xl border border-hairline bg-white p-7 shadow-card sm:p-8" data-id="element-50" data-mp="3kmc42x05g4jh">
      <h3 className="text-lg font-semibold text-ink" data-id="element-51" data-mp="vwc94ehxwby7">Send us a message</h3>
      <p className="mt-1.5 text-sm leading-relaxed text-ink-muted" data-id="element-52" data-mp="zujnx3suf36r">
        Tell us briefly about your business and what you are looking for.
      </p>

      <div className="mt-6 space-y-5" data-id="element-53" data-mp="2rxo2h38i5gbu">
        <div data-id="element-54" data-mp="2rwmdrvykcvbn">
          <label htmlFor="name" className="text-sm font-medium text-ink" data-id="element-55" data-mp="2rww97z2dnuoq">
            Name
          </label>
          <input id="name" name="name" type="text" autoComplete="name" value={name} onChange={e => setName(e.target.value)} aria-invalid={Boolean(errors.name)} aria-describedby={errors.name ? 'name-error' : undefined} className={fieldClass} placeholder="Jane Miller" data-id="element-56" data-mp="35wdwub3xt1wi" />
          {errors.name && <p id="name-error" className="mt-1.5 text-sm text-red-600" data-id="element-57" data-mp="2i7uro4g6p58n">
              {errors.name}
            </p>}
        </div>

        <div data-id="element-58" data-mp="1ugpbtpa8ucyc">
          <label htmlFor="email" className="text-sm font-medium text-ink" data-id="element-59" data-mp="1ugfhxqm2vlnd">
            Email
          </label>
          <input id="email" name="email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} aria-invalid={Boolean(errors.email)} aria-describedby={errors.email ? 'email-error' : undefined} className={fieldClass} placeholder="jane@company.com" data-id="element-60" data-mp="1pgulpnyalrec" />
          {errors.email && <p id="email-error" className="mt-1.5 text-sm text-red-600" data-id="element-61" data-mp="ooce44vamyi5">
              {errors.email}
            </p>}
        </div>

        <div data-id="element-62" data-mp="spo4wdpwlprx">
          <label htmlFor="message" className="text-sm font-medium text-ink" data-id="element-63" data-mp="socye652q3x4">
            Message
          </label>
          <textarea id="message" name="message" rows={4} value={message} onChange={e => setMessage(e.target.value)} aria-invalid={Boolean(errors.message)} aria-describedby={errors.message ? 'message-error' : undefined} className={`${fieldClass} resize-y`} placeholder="A few lines about your company and your goals." data-id="element-64" data-mp="jpso9tdkx2ki" />
          {errors.message && <p id="message-error" className="mt-1.5 text-sm text-red-600" data-id="element-65" data-mp="3exn9q17qmstj">
              {errors.message}
            </p>}
        </div>
      </div>

      <button type="submit" className="mt-6 w-full whitespace-nowrap rounded-lg bg-accent px-6 py-3 text-[15px] font-medium text-white transition-colors duration-150 ease-out hover:bg-accent-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 sm:w-auto" data-id="element-66" data-mp="35z1izis447ho">
        Get in touch
      </button>
    </form>;
}